export function normalizePhone(input: string): string {
  const trimmed = input.trim();
  const hasPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D/g, "");
  return hasPlus ? "+" + digits : digits;
}

export function isValidRussianPhone(input: string): boolean {
  const raw = input.trim();

  if (/[A-Za-zА-Яа-я]/.test(raw)) return false;

  if (/-{2,}/.test(raw)) return false;
  if (/^-+/.test(raw)) return false;
  if (/-+$/.test(raw)) return false;

  const normalized = normalizePhone(raw);

  if (normalized.startsWith("+")) {
    if (!normalized.startsWith("+7")) return false;

    const digits = normalized.slice(2);
    if (!/^\d{10}$/.test(digits)) return false;
    if (/^(\d)\1{9}$/.test(digits)) return false;
    return true;
  }

  if (!/^[78]\d{10}$/.test(normalized)) return false;

  const digits = normalized.slice(1);
  if (/^(\d)\1{9}$/.test(digits)) return false;

  return true;
}

// Маска для инпута: +7 (999) 123-45-67
// nextRaw — новое значение из input
// prevFormatted — предыдущее отформатированное значение (formData.phone)
export function formatRussianPhoneInput(
  nextRaw: string,
  prevFormatted: string = ""
): string {
  let digits = nextRaw.replace(/\D/g, "");
  const prevDigits = prevFormatted.replace(/\D/g, "");

  if (digits === prevDigits && nextRaw.length === prevFormatted.length - 1) {
    digits = digits.slice(0, -1);
  }

  if (!digits) return "";


  if (digits[0] === "8") {
    digits = "7" + digits.slice(1);
  } else if (digits[0] === "9") {
    digits = "7" + digits;
  }

  digits = digits.slice(0, 11);

  if (digits[0] !== "7") {
    return nextRaw;
  }

  const rest = digits.slice(1);
  let result = "+7";

  if (rest.length > 0) {
    result += " (" + rest.slice(0, Math.min(3, rest.length));
  }

  if (rest.length >= 3) {
    result += ")";
  }

  if (rest.length > 3) {
    result += " " + rest.slice(3, Math.min(6, rest.length));
  }

  if (rest.length > 6) {
    result += "-" + rest.slice(6, Math.min(8, rest.length));
  }

  if (rest.length > 8) {
    result += "-" + rest.slice(8, Math.min(10, rest.length));
  }

  return result;
}
